/* eslint-disable @typescript-eslint/no-explicit-any */
import StatusCode from 'status-code-enum';
import { GetTransactionStatus } from '../contracts';
import { TransactionStatus } from '@ace-clublabs/payment-types';

export const GetTransactionStatusStub: GetTransactionStatus = async (id: string) => {
  return {
    statusCode: StatusCode.SuccessOK,
    transactionStatus: TransactionStatus.Succeeded,
  } as any;
};
